/* 🤖 this file was generated by svg-to-ts */
export const matIconGrade: {
  name: 'grade';
  data: string;
} = {
  name: 'grade',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m12 7.13.97 2.29.47 1.11 1.2.1 2.47.21-1.88 1.63-.91.79.27 1.18.56 2.41-2.12-1.28-1.03-.64-1.03.62-2.12 1.28.56-2.41.27-1.18-.91-.79-1.88-1.63 2.47-.21 1.2-.1.47-1.11.97-2.27M12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2z"/></svg>`
};
